import getClientSideSplitTreatments from "./getClientSideSplitTreatments";
import getServerSideSplitTreatments from "./getServerSideSplitTreatments";
import isClientSide from "./isClientSide";
/**
 * Function for getting treatments from a component's `getInitialProps` method
 *
 * @param treatmentNames - The treatment(s) you want to retrieve from Split
 * @param splitKey - The Split key (or Promise of Split key) to be used
 * @param options.apiPathString - The path to your application's treatment endpoint to override default.
 * @param options.attributes - Additional attributes to send to Split.
 **/
const getSplitTreatmentsInGetInitialProps = (treatmentNames, splitKey, { attributes, apiPathString } = {}) => {
    if (isClientSide()) {
        return getClientSideSplitTreatments(treatmentNames, splitKey, {
            apiPathString,
            attributes,
        });
    }
    return getServerSideSplitTreatments(treatmentNames, splitKey, {
        attributes,
    });
};
export default getSplitTreatmentsInGetInitialProps;
